"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@waglabs/link"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var EmailLink = function EmailLink(_ref) {
  var bcc = _ref.bcc,
      body = _ref.body,
      cc = _ref.cc,
      children = _ref.children,
      email = _ref.email,
      subject = _ref.subject,
      props = _objectWithoutPropertiesLoose(_ref, ["bcc", "body", "cc", "children", "email", "subject"]);

  return _react.default.createElement(_link.default, _extends({
    href: "mailto:" + email + "?subject=" + subject + "&body=" + body + "&cc=" + cc + "&bcc=" + bcc
  }, props), children);
};

exports.EmailLink = EmailLink;
EmailLink.defaultProps = {
  bcc: '',
  body: '',
  color: '#00BF8F',
  cc: '',
  subject: ''
};